<template>
  <div>
    <h1 class="mt-3">Booking Guide</h1>
    <form @submit.prevent="submitForm" id="booking-guide-form">
      <div class="form-group">
        <label for="quill-editor">Instructions / Guide</label>
        <WysiwygEditor v-model="content" />
      </div>
      <div class="mt-3">
        <button type="submit" class="btn btn-primary">Save Guide</button>
      </div>
    </form>
    <div v-if="saveSuccess" class="alert alert-success mt-3" role="alert">
      Booking guide er opdateret.
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import WysiwygEditor from './components/WysiwygEditor.vue'

export default {
  components: { WysiwygEditor },
  props: {
    updateUrl: { type: String, required: true }
  },
  setup(props) {
    const content = ref('');
    onMounted(() => {
      // Read initial content from <script type="application/json"> block
      const el = document.getElementById('booking-guide-initial-content');
      if (el) {
        try {
          let raw = JSON.parse(el.textContent || el.innerText || '""');
          // Unescape HTML entities
          const tmp = document.createElement('textarea');
          tmp.innerHTML = raw;
          content.value = tmp.value || tmp.innerHTML;
        } catch (e) {
          content.value = '';
        }
      }
    });

    const saveSuccess = ref(false);
    async function submitForm() {
      try {
        await axios.put(props.updateUrl, { booking_guide: { content: content.value } });
        saveSuccess.value = true;
        setTimeout(() => { saveSuccess.value = false; }, 3000);
      } catch (e) {
        // optionally show error
        console.error('Failed to save booking guide', e);
      }
    }

    return {
      content,
      submitForm,
      saveSuccess
    };
  }
};
</script>
